import { useLayoutEffect, useRef, useState } from 'react'

import { useAnimationFrame } from '../../../../../hooks'
import {
  getRentalPortalProfileHeaderFooterActionsVisibleCount,
  getRentalPortalProfileHeaderFooterActionWidths,
  getRentalPortalProfileHeaderFooterCachedActionWidths,
} from '../../RentalPortalProfileHeaderFooter.utils'

export function useRentalPortalProfileHeaderFooterMeasure({ actions }) {
  const [visibleActionsCount, setVisibleActionsCount] = useState(actions.length)

  const addNewTextMeasureRef = useRef(null)
  const addNewTextRef = useRef(null)
  const containerRef = useRef(null)
  const containerResizeObserverRef = useRef(null)
  const moreButtonMeasureRef = useRef(null)
  const actionButtonRefs = useRef({})
  const actionWidthsByKeyRef = useRef({})
  const actionsRef = useRef(actions)

  function handleMeasure() {
    if (containerRef.current) {
      const { actionWidths, actionWidthsByKey } =
        getRentalPortalProfileHeaderFooterActionWidths({
          actionButtonRefs: actionButtonRefs.current,
          actions: actionsRef.current,
          actionWidthsByKey: actionWidthsByKeyRef.current,
        })

      actionWidthsByKeyRef.current = actionWidthsByKey

      const nextVisibleActionsCount =
        getRentalPortalProfileHeaderFooterActionsVisibleCount({
          actionWidths,
          addNewTextWidth:
            addNewTextMeasureRef.current?.offsetWidth ||
            addNewTextRef.current?.offsetWidth ||
            0,
          containerWidth: containerRef.current.clientWidth,
          moreButtonWidth: moreButtonMeasureRef.current?.offsetWidth || 0,
        })

      setVisibleActionsCount(previousValue =>
        previousValue === nextVisibleActionsCount
          ? previousValue
          : nextVisibleActionsCount
      )
    }
  }

  const [scheduleMeasure, cancelMeasure] = useAnimationFrame(handleMeasure)

  function handleContainerRef(node) {
    containerRef.current = node

    containerResizeObserverRef.current?.disconnect()
    containerResizeObserverRef.current = null

    if (node) {
      containerResizeObserverRef.current = new ResizeObserver(scheduleMeasure)
      containerResizeObserverRef.current.observe(node)
    }
  }

  useLayoutEffect(() => {
    actionsRef.current = actions

    actionWidthsByKeyRef.current =
      getRentalPortalProfileHeaderFooterCachedActionWidths({
        actions,
        actionWidthsByKey: actionWidthsByKeyRef.current,
      })
    actionButtonRefs.current = {}

    handleMeasure()
  })

  useLayoutEffect(() => cancelMeasure, [cancelMeasure])

  function getActionButtonRef(actionKey) {
    return node => {
      if (node) {
        actionButtonRefs.current[actionKey] = node
        actionWidthsByKeyRef.current[actionKey] = node.offsetWidth
      } else {
        delete actionButtonRefs.current[actionKey]
      }
    }
  }

  return {
    addNewTextMeasureRef,
    addNewTextRef,
    getActionButtonRef,
    handleContainerRef,
    hiddenActions: actions.slice(visibleActionsCount),
    moreButtonMeasureRef,
    visibleActions: actions.slice(0, visibleActionsCount),
  }
}
